/**
 * Single source of truth for the Free plan's feature copy.
 *
 * Why this file exists: the positive bullets on the Free card come from the
 * admin-editable `free_plan_features` site setting, but the *limits* must always
 * be shown and must always be worded the same way, on both the public pricing
 * page and the signup plan picker. Two components were drifting apart.
 */

// Only elite-tier members can reach a free member.
export const ELITE_CONTACT_LINE = "Get contacted by elite members only";

// Always shown as not-included on the Free card, whatever the admin list says.
export const FREE_PLAN_LIMITS = [
  "You can't contact members until you upgrade",
  "Free members cannot contact you",
  "No WhatsApp support",
];

// ── Simple plans mode (Admin → Settings → Simple plans) ──────────────────
// Only Free + one Paid plan are on sale. Free cannot contact anyone and has
// no WhatsApp support, but does get psychological compatibility scores.
export const SIMPLE_FREE_FEATURES = [
  "Your profile is live and visible to members",
  "Browse all profiles",
  "Psychological compatibility scores",
];

export const SIMPLE_FREE_LIMITS = [
  "You can't contact anyone",
  "No profession & education filters",
  "No WhatsApp support",
];

// Admin-list bullets we never render on the Free card, because the limits
// below already say it (and said it better).
const DROPPED = [
  "contact members yourself",
  "upgrade anytime to contact others",
  "upgrade anytime to view contact details",
];

// Any older "contacted by paid members" wording is rewritten, so a stale value
// in the site settings cannot contradict the elite-only rule on screen.
export const normalizeFreeFeature = (text) => {
  const value = String(text);
  if (/contacted\s+by\b.*\bmembers/i.test(value)) return ELITE_CONTACT_LINE;
  return value;
};

export const isDroppedFreeFeature = (text) =>
  DROPPED.includes(String(text).trim().toLowerCase()) ||
  // An admin list promising WhatsApp support on Free would contradict the
  // limits; drop it rather than render both.
  /whatsapp/i.test(String(text));

export default FREE_PLAN_LIMITS;
